module.exports = __webpack_public_path__ + "static/media/nato_strap_black_red.3a5dc179.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nato_strap_black_red.png
// module id = 112
// module chunks = 0